import React, { useState, useEffect } from 'react';
import {
  Typography,
  Box,
  Backdrop,
  CircularProgress,
  IconButton,
  Tooltip,
  Modal,
  Button,
  Card,
} from '@mui/material';
import StudentInfoCard from '../../../components/StudentInfoCard';
import AddFeePayment from '../../../components/AddFeePayment';
import ModalDialog from '../../../components/UIElements/ModalDialog';
import {
  deleteTransactionById,
  getPaymentDetails,
  postPaymentDetails,
} from '../../../features/payments/PaymentSlice';
import { useDispatch, useSelector } from 'react-redux';
import { getStudentById } from '../../../features/student/studentSlice';
import { DataGrid } from '@mui/x-data-grid';
import { BsFileEarmarkPdf } from 'react-icons/bs';
import api from '../../../services/api';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import CloseIcon from '@mui/icons-material/Close';
import PersonIcon from '@mui/icons-material/Person';
import useNotification from '../../../hooks/useNotification';
import ToastNotification from '../../../components/UIElements/ToastNotification';
export default function StudentTutionFee({ StudentId }) {
  const dispatch = useDispatch();
  const [feeDetailsList, setFeeDetailsList] = useState([]);
  const [deletedReceipts, setDeletedReceipts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [studentData, setStudnetData] = useState('');
  const [open, setOpen] = useState(false); //Modal opening For AddFeePayments
  const [deleteModal, setDeleteModal] = useState(false);
  const { userDetails } = useSelector((state) => state.auth?.successData ?? {});
  const { notification, showSuccess, showError, hideNotification } =
    useNotification();
  useEffect(() => {
    getFeeDetailsList();
  }, [StudentId]);
  async function getFeeDetailsList() {
    if (StudentId) {
      setLoading(true);
      try {
        const receiptsInfo = await dispatch(
          getPaymentDetails(StudentId),
        ).unwrap();
        setFeeDetailsList(receiptsInfo?.receipts);
        setDeletedReceipts(receiptsInfo?.deletedReceipts ?? []);
        const data = await dispatch(getStudentById(StudentId)).unwrap();
        setStudnetData(data);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    } else {
      setFeeDetailsList([]);
      setDeletedReceipts([]);
      setStudnetData('');
    }
  }

  const handleAddPayment = async (formData) => {
    const newPayments = [
      {
        receiptNo: formData.transactionReference,
        paidOn: new Date().toLocaleDateString('en-GB'),
        amount: parseFloat(formData.amount),
        writeOffRemaining: formData.writeOffRemaining,
        paymentType: formData.paymentType,
      },
    ];
    try {
      setLoading(true);
      const response = await dispatch(
        postPaymentDetails({
          studentId: StudentId,
          receipts: newPayments,
        }),
      ).unwrap();
      if (response.data && response.status == 200) {
        getFeeDetailsList();
        showSuccess('Payment saved successfully');
        return true;
      }
      return false;
    } catch {
      console.log('Error in saving payment details');
      showError('Error in saving payment details.');
    } finally {
      setLoading(true);
    }
  };
  async function downloadReceipt(param) {
    try {
      const fileResponse = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: '/students/payments/download-receipt',
        method: 'GET',
        responseType: 'blob',
        headers: { id: param.id },
      });
      const blob = new Blob([fileResponse?.data], {
        type: fileResponse.headers['content-type'],
      });

      let filename = `${param.row.receiptNo || 'Receipt'}.pdf`;
      const contentDisposition = fileResponse?.headers['content-disposition'];
      const match = contentDisposition?.match(/filename="?(.+)"?/);

      if (match?.[1]) filename = match[1];

      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      link.click();
      URL.revokeObjectURL(url);
    } catch (err) {
      alert('Error in Downloading');
      console.error('Download failed', err);
    } finally {
      setLoading(false);
    }
  }
  async function deleteTransaction(id) {
    try {
      const response = await dispatch(deleteTransactionById(id)).unwrap();
      if (response) {
        // const list = await dispatch(getPaymentDetails(StudentId)).unwrap();
        // setFeeDetailsList(list);
        setDeleteModal(false);
        getFeeDetailsList();
      } else {
        alert('Error in deleting the payment');
      }
    } catch (error) {
      console.log(error);
      alert('Error in deleting the payment');
    } finally {
      setLoading(false);
    }
  }
  return (
    <>
      <Box className='pt-2 px-1 md:px-4 relative '>
        {!studentData && loading && (
          <Backdrop
            open
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              zIndex: (theme) => theme.zIndex.drawer + 1,
              width: '100%',
              height: '100%',
            }}
            className='bg-white'
          >
            <div>
              <div className='text-center'>
                <CircularProgress color='primary' />
              </div>
              <br />
              <div className='text-center '>
                Fetching Details.. of {StudentId}{' '}
              </div>
            </div>
          </Backdrop>
        )}

        {StudentId && !studentData && (
          <Card className='flex justify-center items-center h-60 border rounded-lg'>
            <Typography variant='body1'>Student details not found</Typography>
          </Card>
        )}
        {!StudentId && !studentData && (
          <Card className='flex flex-col justify-center items-center h-60 border rounded-lg'>
            <PersonIcon
              className='text-gray-300 mb-1'
              style={{ fontSize: 90 }}
            />
            <Typography variant='h6' className='text-gray-400 mb-2'>
              No Student Selected
            </Typography>
            <Typography variant='body2' className='text-gray-500'>
              Please search for a student to know payment details.
            </Typography>
          </Card>
        )}

        {studentData && (
          <div>
            <StudentInfoCard
              student={studentData}
              onAddClick={() => setOpen(true)}
              balance={studentData?.feeDue}
              writeOffRemaining={feeDetailsList?.at(-1)?.writeOffRemaining}
            />
            <div className='flex flex-wrap items-start justify-between mt-2'>
              <div className='mr-2'>
                <Typography variant='body1' className='font-bold mt-1 '>
                  Payment History
                </Typography>
              </div>
              <div className='flex flex-wrap items-end pt-2'>
                <Typography>
                  Total Paid :{' '}
                  <span className='text-green-500'>
                    {studentData?.totalPaid}
                  </span>{' '}
                  ,
                </Typography>
                <Typography>
                  <>
                    TotalBalance :
                    <span className='text-red-400'>{studentData?.feeDue} </span>{' '}
                    {feeDetailsList?.at(-1)?.writeOffRemaining && (
                      <span className='text-xl text-red-500'>(WrittenOff)</span>
                    )}
                  </>
                </Typography>
              </div>
            </div>
            {/* Payments Table */}
            <div className='w-full overflow-auto'>
              <div className='border mt-2 rounded  h-auto min-w-[800px] '>
                <DataGrid
                  sx={{
                    '& .MuiDataGrid-columnHeaderTitle': {
                      fontSize: '16px',
                      fontWeight: '600',
                      color: '#1976d2',
                    },
                    maxHeight: '70vh',
                    '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within':
                      {
                        outline: 'none',
                        '& .MuiDataGrid-row:hover': {
                          backgroundColor: '#ffffff',
                        },
                      },
                    ' .MuiDataGrid-columnHeader': {
                      backgroundColor: '#f9faff',
                      position: 'sticky',
                      top: 0,
                      zIndex: 10,
                    },
                    '.MuiDataGrid-virtualScroller': {
                      maxHeight: 'calc(70vh - 120px)',
                      overflow: 'auto',
                    },
                  }}
                  rows={
                    Array.isArray(feeDetailsList)
                      ? [...feeDetailsList]?.reverse()
                      : []
                  }
                  columns={[
                    {
                      field: 'receiptNo',
                      headerName: 'Receipt No',
                      flex: 1,
                      sortable: false,
                    },
                    {
                      field: 'paidOn',
                      headerName: 'Paid On',
                      flex: 1,
                      sortable: false,
                    },
                    {
                      field: 'amount',
                      headerName: 'Amount',
                      flex: 1,
                      sortable: false,
                    },
                    {
                      field: 'dueAmount',
                      headerName: 'Due Amount',
                      flex: 1,
                      sortable: false,
                    },
                    {
                      field: 'paymentType',
                      headerName: 'Payment Type',
                      flex: 1,
                      sortable: false,
                    },
                    {
                      field: 'createdBy',
                      headerName: 'Accountant',
                      flex: 1,
                      sortable: false,
                      renderCell: (param) => {
                        return (
                          <Tooltip title={param?.row?.email ?? 'No email'}>
                            {param?.row?.createdBy}
                          </Tooltip>
                        );
                      },
                    },
                    {
                      field: '',
                      headerName: 'Actions',
                      flex: 1,
                      sortable: false,
                      minWidth: 100,
                      renderCell: (param) => (
                        <div className='flex items-center cursor-pointer'>
                          <Tooltip
                            title='Download Transaction Receipt'
                            enterDelay={0}
                          >
                            <IconButton
                              onClick={() => {
                                setLoading(true);
                                downloadReceipt(param);
                              }}
                              className=' text-red-600'
                            >
                              <BsFileEarmarkPdf />
                            </IconButton>
                          </Tooltip>
                          {userDetails &&
                            userDetails?.role?.toLowerCase() === 'admin' && (
                              <Tooltip
                                title='Delete Transaction '
                                enterDelay={0}
                              >
                                <IconButton
                                  onClick={() => {
                                    setDeleteModal(param?.row?.id);
                                  }}
                                  className=' text-red-500'
                                >
                                  <DeleteForeverIcon />
                                </IconButton>
                              </Tooltip>
                            )}
                          {/* <span>Download Receipt</span> */}
                        </div>
                      ),
                    },
                  ]}
                  hideFooter={true}
                  disableColumnMenu
                  getRowClassName={(params) =>
                    params.row.dueAmount ===
                    (feeDetailsList?.length > 0
                      ? feeDetailsList?.at(-1).dueAmount
                      : [])
                      ? 'bg-gray-100 font-semibold'
                      : ''
                  }
                />
              </div>
            </div>
            {/* Deleted History */}
            {deletedReceipts?.length > 0 && (
              <div>
                <Typography variant='body1' className='font-bold mt-2 '>
                  Deleted Payments
                </Typography>
                <div className='w-full overflow-auto'>
                  <div className='border mt-2 rounded  h-auto min-w-[800px] '>
                    <DataGrid
                      sx={{
                        '& .MuiDataGrid-columnHeaderTitle': {
                          fontSize: '16px',
                          fontWeight: '600',
                          color: '#1976d2',
                        },
                        maxHeight: '70vh',
                        '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within':
                          {
                            outline: 'none',
                            '& .MuiDataGrid-row:hover': {
                              backgroundColor: '#ffffff',
                            },
                          },
                        ' .MuiDataGrid-columnHeader': {
                          backgroundColor: '#f9faff',
                          position: 'sticky',
                          top: 0,
                          zIndex: 10,
                        },
                        '.MuiDataGrid-virtualScroller': {
                          maxHeight: 'calc(70vh - 120px)',
                          overflow: 'auto',
                        },
                      }}
                      rows={
                        Array.isArray(deletedReceipts)
                          ? [...deletedReceipts].reverse()
                          : []
                      }
                      columns={[
                        {
                          field: 'receiptNo',
                          headerName: 'Receipt No',
                          flex: 1,
                          sortable: false,
                        },
                        {
                          field: 'paidOn',
                          headerName: 'Paid On',
                          flex: 1,
                          sortable: false,
                        },
                        {
                          field: 'amount',
                          headerName: 'Amount',
                          flex: 1,
                          sortable: false,
                        },
                        {
                          field: 'dueAmount',
                          headerName: 'Due Amount',
                          flex: 1,
                          sortable: false,
                        },
                        {
                          field: 'paymentType',
                          headerName: 'Payment Type',
                          flex: 1,
                          sortable: false,
                        },
                        {
                          field: 'createdBy',
                          headerName: 'Created By',
                          flex: 1,
                          sortable: false,
                        },
                        {
                          field: 'deletedBy',
                          headerName: 'Deleted By',
                          flex: 1,
                          sortable: false,
                        },
                      ]}
                      hideFooter={true}
                      disableColumnMenu
                      getRowClassName={(params) =>
                        params.row.dueAmount ===
                        (feeDetailsList?.length > 0
                          ? feeDetailsList?.at(-1).dueAmount
                          : [])
                          ? 'bg-gray-100 font-semibold'
                          : ''
                      }
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        )}

        {/* Model For Uploading the Fee Details */}
        <ModalDialog
          size='sm'
          isOpen={open}
          onClose={() => setOpen(false)}
          title='Add Fee Payment'
        >
          <AddFeePayment
            onSubmission={handleAddPayment}
            onClose={() => setOpen(false)}
            balance={studentData?.feeDue}
            isSubmitting={loading}
          />
        </ModalDialog>
        {/* PreDelete Modal */}
        <Modal
          open={deleteModal}
          onClose={() => setDeleteModal(false)}
          aria-labelledby='modal-modal-title'
          aria-describedby='modal-modal-description'
        >
          <div className='bg-white fixed top-1/2 left-1/2  -translate-x-1/2 -translate-y-1/2  rounded-md min-w-80'>
            <div className='flex justify-between border-b p-3 rounded-t-md'>
              <Typography variant='h5'>Alert !</Typography>
              <CloseIcon
                size='large'
                onClick={() => {
                  setDeleteModal(false);
                }}
              />
            </div>

            <div className='p-10'>
              <Typography variant='h6'>
                {' '}
                Are you sure ,you want to delete the details ?
              </Typography>
              <Typography variant='body2' color='error' className='mt-1'>
                {' '}
                Note : Data will be deleted permanently.
              </Typography>

              <div className='flex justify-evenly mt-5'>
                <Button
                  size='small'
                  variant='outlined'
                  color='error'
                  onClick={() => setDeleteModal(false)}
                  className='font-semibold rounded-lg   py-2 px-6'
                >
                  No
                </Button>
                <Button
                  size='small'
                  variant='contained'
                  onClick={async () => {
                    setLoading(true);
                    deleteTransaction(deleteModal);
                  }}
                  className='normal-case text-base font-semibold rounded-lg text-white  py-2 px-6'
                  style={{
                    background:
                      'linear-gradient(90deg,#f72e14  0%, #e0a955 100%)',
                  }}
                >
                  DELETE
                </Button>
              </div>
            </div>
          </div>
        </Modal>
      </Box>
      <ToastNotification
        open={notification.open}
        onClose={hideNotification}
        message={notification.message}
        title={notification.title}
        severity={notification.severity}
        autoHideDuration={notification.autoHideDuration}
        position={notification.position}
      />
    </>
  );
}
